/* @flow */
import * as React from 'react';
import { Container } from 'flux/utils';
import invariant from 'invariant';

import ChatMessageStore from 'chat/stores/ChatMessageStore';
import CurrentUser from 'auth/CurrentUser';
import DeliveryStore, { Marker } from 'stores/DeliveryStore';
import ReadReceipt from 'chat/components/ReadReceipt.jsx';
import { ChatMessage } from 'entities/ChatMessage';
import MessageDelivery from 'entities/MessageDelivery';
import ChatMessages from 'collections/ChatMessages';

import './styles/ChatReadReceipt.scss';

export class ChatReadReceipt extends React.Component<{
  message: ChatMessage,
  labelDisplay?: boolean,
  glyphDisplay?: boolean,
  hovered?: boolean,

  delivery: MessageDelivery,
  marker: Marker,
  messages: ChatMessages,
}> {
  static defaultProps = {
    labelDisplay: true,
  };

  getLastMessageReceivedSequence(): ?number {
    const chatMessages = this.props.messages
      .filter(message => {
        return (
          message instanceof ChatMessage &&
          message.getSender().getUuid() !== CurrentUser.getUserUuid()
        );
      })
      .sort((a, b) => {
        return b.getSeq() - a.getSeq();
      });

    if (chatMessages && chatMessages[0]) {
      return chatMessages[0].getSeq();
    }

    return null;
  }

  render() {
    if (!this.props.delivery) {
      return null;
    }

    if (!this.props.delivery.getReadSummary()) {
      return null;
    }

    // we only display a read receipt before the
    // last received message when item is hovered.
    const shouldHide =
      !this.props.hovered &&
      // $FlowFixMe these are both nullable
      this.getLastMessageReceivedSequence() > this.props.message.getSeq();

    if (shouldHide) {
      return null;
    }

    /* If we received a marker for that stream about the readSeq
     * then we show all previous message as read. The "read" status
     * will show up in the read summary otherwise!
     */
    const shouldBeMarkAsRead: boolean =
      this.props.marker && this.props.marker.readSeq >= (this.props.message.getSeq() || 0);

    // $FlowIssue
    const status: LegacyMessageDeliveryStatusType = shouldBeMarkAsRead
      ? 'read'
      : this.props.delivery.getReadSummary().getState();

    return (
      <div className="ChatReadReceipt">
        {status && (
          <span>
            {this.props.labelDisplay && <span className="ChatReadReceipt-spacer">{' • '}</span>}
            <ReadReceipt
              labelDisplay={this.props.labelDisplay}
              glyphDisplay={this.props.glyphDisplay}
              errorCount={this.props.delivery.getReadSummary().getFailedCount()}
              status={status}
            />
          </span>
        )}
      </div>
    );
  }
}
class ChatReadReceiptContainer extends React.Component<
  {
    message: ChatMessage, // eslint-disable-line react/no-unused-prop-types
  },
  *
> {
  static getStores() {
    return [DeliveryStore, ChatMessageStore];
  }
  static calculateState(prevState, props) {
    return {
      delivery: DeliveryStore.getDeliveryByMessageId(props.message.id),
      marker: DeliveryStore.getMarkerForStream(props.message.getChatId()),
      messages: ChatMessageStore.getChatMessages(props.message.getChatId()),
    };
  }
  render() {
    invariant(this.state, 'state not defined');
    return <ChatReadReceipt {...this.props} {...this.state} />;
  }
}
export default Container.create(ChatReadReceiptContainer, { withProps: true });
